import {Checkbox, Stack} from '@mantine/core';
import React from 'react';

import {AntibodyEnforcedNamingStrategySpec} from 'antibodies/schema-configuration/AntibodyEnforcedDataModelConstants';
import {LABELING_STRATEGY_TO_TEXT, RegistryLabelingStrategy} from 'constants/RegistryConstants';
import getTestProps from 'test/lib/cypress/getTestProps';

import MigrationPreviewSection from './MigrationPreviewSection';

export interface NamingStrategyMigrationPreviewProps {
  enforcedNamingStrategySpec: AntibodyEnforcedNamingStrategySpec;
  existingNamingStrategies: Array<RegistryLabelingStrategy> | null;
}

export default function NamingStrategyMigrationPreview({
  enforcedNamingStrategySpec,
  existingNamingStrategies,
}: NamingStrategyMigrationPreviewProps): JSX.Element {
  const atLeastOneOfStrategies = enforcedNamingStrategySpec.validNamingStrategies.map(
    (strategy) => RegistryLabelingStrategy[strategy]
  );
  if (
    existingNamingStrategies != null &&
    existingNamingStrategies.some((strategy) => atLeastOneOfStrategies.includes(strategy))
  ) {
    return (
      <MigrationPreviewSection title="Labeling strategies" description="No changes to labeling strategies." />
    );
  }
  return (
    <MigrationPreviewSection
      title="Labeling strategies"
      description="New labeling strategies will be added to the schema."
    >
      <Stack
        spacing="xs"
        {...getTestProps({component: 'NamingStrategyMigrationPreview', element: 'strategies'})}
      >
        {atLeastOneOfStrategies.map((strategy) => (
          <Checkbox
            key={strategy}
            checked={true}
            disabled={true}
            label={LABELING_STRATEGY_TO_TEXT[strategy]}
            value={strategy}
          />
        ))}
      </Stack>
    </MigrationPreviewSection>
  );
}
